<template>
    <!-- BEGIN SIDEBAR -->
    <div class="page-sidebar-wrapper">
        <!-- BEGIN SIDEBAR -->

        <div class="page-sidebar navbar-collapse" :class="{collapse: collapsed}">
            <!-- BEGIN SIDEBAR MENU -->
            <!-- DOC: Apply "page-sidebar-menu-light" class right after "page-sidebar-menu" to enable light sidebar menu style(without borders) -->
            <!-- DOC: Apply "page-sidebar-menu-closed" class right after "page-sidebar-menu" to collapse("page-sidebar-closed" class must be applied to the body element) the sidebar sub menu mode -->
            <ul class="page-sidebar-menu page-header-fixed " :class="{'page-sidebar-menu-closed': collapsed}"
                style="padding-top: 20px">

                <v-sidebar-search></v-sidebar-search>

                <v-sidebar-item-group
                        v-if="currentSection === appSections['clo']"
                        routeGroup="CloDashboard" :title="$t('nav.DASHBOARD')"
                        icon="icon-home">
                    <template slot-scope="props">
                        <v-slide-toggle-transition>
                            <ul class="sub-menu"
                                v-show="props.expanded">
                                <v-sidebar-link routeName="clo.dashboard" :title="$t('nav.DEALS')"
                                                icon="icon-grid"></v-sidebar-link>
                                <v-sidebar-link routeName="clo.surveys" :title="$t('nav.SURVEYS')"
                                icon="icon-bubbles"></v-sidebar-link>
                                <!--<v-sidebar-link routeName="clo.test.invoicing" :title="$t('nav.INVOICES')"-->
                                                <!--icon="icon-list"></v-sidebar-link>-->
                            </ul>
                        </v-slide-toggle-transition>
                    </template>
                </v-sidebar-item-group>

                <v-sidebar-item-group
                        v-if="currentSection === appSections['clo'] && selectedDeal"
                        routeGroup="CloDeal" :title="$t('nav.OFFER')"
                        icon="icon-briefcase">
                    <template slot-scope="props">
                        <v-slide-toggle-transition>
                            <ul class="sub-menu" v-show="props.expanded">
                                <v-sidebar-link routeName="clo.deal.stats" :routeParams="{offerId: selectedDeal.id}" title="Statistics"
                                                icon="icon-speedometer"></v-sidebar-link>
                                <!--<v-sidebar-link routeName="clo.deal.clients" title="List of clients"-->
                                                <!--icon="icon-grid"></v-sidebar-link>-->

                                <v-sidebar-item-group :title="$t('nav.CHARTS')"
                                                      icon="icon-pie-chart">
                                    <template slot-scope="props">
                                        <v-slide-toggle-transition>
                                            <ul class="sub-menu" v-show="props.expanded">
                                                <v-sidebar-link routeName="clo.deal.claims" :routeParams="{offerId: selectedDeal.id}" :title="$t('nav.CLAIMS')"
                                                                icon="icon-chart"></v-sidebar-link>
                                                <v-sidebar-link routeName="clo.deal.sales" :routeParams="{offerId: selectedDeal.id}" :title="$t('nav.SALES')"
                                                                icon="icon-chart"></v-sidebar-link>
                                            </ul>
                                        </v-slide-toggle-transition>
                                    </template>
                                </v-sidebar-item-group>

                                <v-sidebar-link routeName="clo.deal.transactions" :title="$t('nav.TRANSACTIONS')"
                                                icon="icon-wallet"></v-sidebar-link>

                                <v-sidebar-link routeName="clo.deal.contactUs" :title="$t('nav.CONTACT_US')"
                                                icon="icon-people"></v-sidebar-link>
                            </ul>
                        </v-slide-toggle-transition>
                    </template>
                </v-sidebar-item-group>

                <!--<li class="heading" v-if="currentSection === appSections['traditional']">-->
                    <!--<h3 class="uppercase">Vouchers</h3>-->
                <!--</li>-->
                <!--<v-sidebar-item-group-->
                        <!--v-if="currentSection === appSections['traditional']"-->
                        <!--routeGroup="Voucher"-->
                        <!--title="Vouchers"-->
                        <!--icon="icon-envelope-letter">-->
                    <!--<template slot-scope="props">-->
                        <!--<v-slide-toggle-transition>-->
                            <!--<ul class="sub-menu" v-show="props.expanded">-->
                                <!--&lt;!&ndash;<v-sidebar-link routeName="voucher.redeem" title="Vouchers"&ndash;&gt;-->
                                <!--&lt;!&ndash;icon="icon-list"></v-sidebar-link>&ndash;&gt;-->
                            <!--</ul>-->
                        <!--</v-slide-toggle-transition>-->
                    <!--</template>-->
                <!--</v-sidebar-item-group>-->

                <!--<li class="heading" v-if="currentSection === appSections['traditional']">-->
                    <!--<h3 class="uppercase">Pages</h3>-->
                <!--</li>-->
                <!--<v-sidebar-item-group-->
                        <!--v-if="currentSection === appSections['traditional']"-->
                        <!--routeGroup="Test" title="Demo pages"-->
                        <!--icon="icon-briefcase">-->
                    <!--<template slot-scope="props">-->
                        <!--<v-slide-toggle-transition>-->
                            <!--<ul class="sub-menu" v-show="props.expanded">-->
                                <!--<v-sidebar-link routeName="test.deals" title="Tuango Plus deals"-->
                                                <!--icon="icon-picture"></v-sidebar-link>-->
                                <!--<v-sidebar-link routeName="test.stats" title="Statistics"-->
                                                <!--icon="icon-speedometer"></v-sidebar-link>-->
                                <!--<v-sidebar-link routeName="test.datatables" title="List of clients"-->
                                                <!--icon="icon-grid"></v-sidebar-link>-->
                                <!--<v-sidebar-link routeName="test.calendar" title="Calendar"-->
                                                <!--icon="icon-calendar"></v-sidebar-link>-->
                                <!--<v-sidebar-link routeName="test.userCard" title="Contact us"-->
                                                <!--icon="icon-people"></v-sidebar-link>-->
                                <!--<v-sidebar-link routeName="test.chart" title="Charts"-->
                                                <!--icon="icon-pie-chart"></v-sidebar-link>-->
                                <!--<v-sidebar-link routeName="test.invoicing" title="Invoicing"-->
                                                <!--icon="icon-note"></v-sidebar-link>-->
                                <!--<v-sidebar-link routeName="test.map" title="Claims hit map"-->
                                                <!--icon="icon-map"></v-sidebar-link>-->
                                <!--<v-sidebar-link routeName="test.surveys" title="Surveys"-->
                                                <!--icon="icon-bubbles"></v-sidebar-link>-->
                            <!--</ul>-->
                        <!--</v-slide-toggle-transition>-->
                    <!--</template>-->
                <!--</v-sidebar-item-group>-->
            </ul>
            <!-- END SIDEBAR MENU -->

        </div>
        <!-- END SIDEBAR -->
    </div>
    <!-- END SIDEBAR -->
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import VSidebarSearch from './SidebarSearch'
  import VSidebarItemGroup from './SidebarItemGroup'
  import VSidebarLink from './SidebarLink'
  import VSlideToggleTransition from '@/app/components/transitions/SlideToggleTransition'

  const $ = require('jquery')
  const {mapState} = createNamespacedHelpers('app')

  export default {
    components: {
      VSidebarSearch,
      VSidebarItemGroup,
      VSidebarLink,
      VSlideToggleTransition
    },
    data () {
      return {
        desktopMq: 992,
        collapsed: true
      }
    },
    computed: {
      ...mapState({
        appSections: state => state.appSections,
        currentSection: state => state.section,
        selectedDeal: state => state.selectedDeal
      })
    },
    methods: {
      windowResize () {
        if (this.$mq.below(this.desktopMq)) {
          this.collapsed = true
        } else {
          this.collapsed = false
        }
        this.changeBodyClass(this.collapsed)
      },
      changeBodyClass (isCollapsed) {
        const $body = $('body')

        if (isCollapsed) {
          $body.addClass('page-sidebar-closed')
        } else {
          $body.removeClass('page-sidebar-closed')
        }
      },
      toggleSidebar () {
        this.collapsed = !this.collapsed
        this.changeBodyClass(this.collapsed)
      }
    },
    watch: {
      '$mq.resize': 'windowResize'
    },
    mounted () {
      this.windowResize()
    }
  }
</script>

<style lang="scss">
    .page-sidebar .page-sidebar-menu li.active > .sub-menu {
        display: none;
    }
</style>



// WEBPACK FOOTER //
// src/app/components/sidebar/Sidebar.vue